import { CSSProperties, FC, useEffect, useState } from "react";
import { AdsSlotWrapper } from "./styled.components";

interface IProp {
  adSizes: ([number, number] | "fluid")[];
  id: string;
  data_aa_adunit: string;
  removePositionCenter?: boolean;
  className?: string;
  disableInitialLoad?: boolean;
  style?: CSSProperties;
}

const Index: FC<IProp> = ({
  adSizes,
  data_aa_adunit,
  id,
  removePositionCenter,
  className = "",
  style,
  disableInitialLoad = true,
}) => {
  const [isGPTReady, setIsGPTReady] = useState(false);

  useEffect(() => {
    window.googletag = window.googletag || ({ cmd: [] } as typeof googletag);
    googletag.cmd.push(() => {
      if (googletag.apiReady && !isGPTReady) setIsGPTReady(true);
      if (disableInitialLoad) googletag.pubads?.()?.disableInitialLoad();
      googletag
        .defineSlot(data_aa_adunit, adSizes, `${id}`)!
        .addService(googletag.pubads?.());
      googletag.pubads?.()?.enableVideoAds();
      googletag.pubads().enableLazyLoad();
      googletag.pubads?.()?.enableSingleRequest();
      googletag.enableServices();
    });
  }, []);
  const isCrossOriginFrame = () => {
    try {
      return !window.top.location.hostname;
    } catch (e) {
      return true;
    }
  };
  useEffect(() => {
    if (isGPTReady && !isCrossOriginFrame()) {
      googletag.cmd.push(() => {
        googletag.display(`${id}`);
        if (!disableInitialLoad) {
          const slots = googletag.pubads?.().getSlots();
          slots.forEach((slot, index) => {
            googletag.cmd.push(() => {
              if (slot.getSlotElementId() === `${id}`)
                googletag.pubads().refresh([slot]);
            });
          });
        }
      });
    }
  }, [isGPTReady, isCrossOriginFrame]);

  const adWrapperProps = {
    key: `${data_aa_adunit}`,
    positionCenter: !removePositionCenter,
    id: `${id}`,
    className: `${className}`,
    style: style,
  };
  return <AdsSlotWrapper {...adWrapperProps} />;
};

export default Index;
